import { http, Result } from "@fider/services/http"

// Tùy biến KHCN: trạng thái dịch vụ AI (Gemini) cho quản trị viên / cộng tác viên
export interface AIStatus {
  enabled: boolean
  available: boolean
  model: string
  reason?: string
  pausedUntil?: string
  lastSuccess?: string
  lastError?: string
}

export const getAIStatus = async (): Promise<Result<AIStatus>> => {
  return http.get<AIStatus>("/api/v1/ai/status")
}

// Tùy biến KHCN: danh sách ảnh banner sự kiện (server liệt kê static/events/)
export const getEventBanners = async (): Promise<Result<string[]>> => {
  return http.get<string[]>("/api/v1/event-banners")
}
